import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import "../../assets/css/contact.css";
import ContactForm from "../../components/ContactForm";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import { Address, Email, Hat2, Location } from "../../constant/Index";
import { useForm } from "../../Hooks/Form";
import { useNewsletterContentMutation } from "../../store/services/NewsletterService";
import { useSiteContentQuery } from "../../store/services/SitesettingService";

const Newsletter = () => {
	const { data, isLoading } = useSiteContentQuery();
	let Siteresponse = data?.response?.data[0];
	const [errors, setErrors] = useState([]);
	const { state, onChange } = useForm({
		email: "",
	});
	let { email } = state;
	const [userNewsletter, response] = useNewsletterContentMutation();

	const onSubmit = (e) => {
		e.preventDefault();
		const FormDatas = new FormData();
		FormDatas.append("email", email);
		userNewsletter(FormDatas);
	};

	useEffect(() => {
		if (response.isError) {
			setErrors(response?.error?.data?.errors);
		}
	}, [response?.error?.data]);

	useEffect(() => {
		if (response.isSuccess) {
			toast.success(response?.data?.message);
			setErrors([]);
			state.email = "";
		}
	}, [response.isSuccess]);
	return (
		<>
			{/* Header Start Here */}
			<Header />
			{/* Header End Here */}

			{/* <!-- Contact Sec Start Here --> */}
			<ContactForm />
			{/* <!-- Contact Sec End Here --> */}

			{/* <!-- Benefits Sec Start Here --> */}
			<section className="benefits_sec contact_benefits">
				<div className="hat-circle">
					<figure>
						<img src={Hat2} alt="nft-hat" className="img-fluid" />
					</figure>
				</div>
				<div className="container">
					<div className="benefit_box">
						<div className="row">
							<div className="col-lg-5"></div>
							<div className="col-lg-7">
								<div className="content-wrapper">
									<div className="heading-wrapper">
										<h4>MONTHLY NEWSLETTER</h4>
										<h2>SUBSCRIBE TO OUR NEWSLETTER</h2>
									</div>
									<p>
										Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
										do eiusmod tempor incididunt ut labore et
									</p>
									{errors && errors?.email && (
										<span className="errorMessage">
											<p className="m-0">{errors && errors?.email}</p>
										</span>
									)}
									<form onSubmit={onSubmit}>
										<div className="form-group">
											<input
												type="email"
												className={`${
													errors && errors?.email
														? "SetErrorshow form-control"
														: "form-control"
												}`}
												id="inputname"
												placeholder="Enter your email"
												name="email"
												value={email}
												onChange={onChange}
											/>
										</div>
										<div className="button-group">
											<button type="submit" className="buy-btn yellow">
												<span className="txt">Submit</span>
												<span className="svg-icon">
													<svg width="28" height="28" viewBox="0 0 28 28">
														<defs>
															<filter
																id="Ellipse_15"
																x="0"
																y="0"
																width="28"
																height="28"
																filterUnits="userSpaceOnUse"
															>
																<feOffset dy="2" input="SourceAlpha" />
																<feGaussianBlur
																	stdDeviation="1"
																	result="blur"
																/>
																<feFlood floodOpacity="0.302" />
																<feComposite operator="in" in2="blur" />
																<feComposite in="SourceGraphic" />
															</filter>
														</defs>
														<g
															id="Group_27"
															data-name="Group 27"
															transform="translate(-340 -668)"
														>
															<g
																transform="matrix(1, 0, 0, 1, 340, 668)"
																filter="url(#Ellipse_15)"
															>
																<circle
																	id="Ellipse_15-2"
																	data-name="Ellipse 15"
																	cx="11"
																	cy="11"
																	r="11"
																	transform="translate(3 1)"
																	fill="#3418fc"
																/>
															</g>
															<path
																id="Path_16"
																data-name="Path 16"
																d="M585.823,402.516a.646.646,0,0,1-.556-.634c0-.054,0-.107,0-.161q0-3.333,0-6.665a1.178,1.178,0,0,1,.069-.419.626.626,0,0,1,.806-.343,2.325,2.325,0,0,1,.541.217q2.694,1.538,5.38,3.087a1.207,1.207,0,0,1,.509.48.736.736,0,0,1-.262.933,2.108,2.108,0,0,1-.255.17l-5.37,3.085a1.994,1.994,0,0,1-.669.249Z"
																transform="translate(-233.954 281.611)"
																fill="#f9f928"
															/>
														</g>
													</svg>
												</span>
											</button>
										</div>
									</form>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			{/* <!-- Benefits Sec End Here --> */}

			{/* Footer Start Here */}
			<Footer />
			{/* Footer End Here */}
		</>
	);
};

export default Newsletter;
